module.exports = __webpack_public_path__ + "img/aboutUs.441b8f09.jpg";